<mat-toolbar class="mat-primary">
  <span fxFlex>Eigene Listenkonfiguration speichern</span>
  <mat-icon class="cursor-mat-element" (click)="cancel()">close</mat-icon>
</mat-toolbar>
<mat-dialog-content>
  <form>
    <p>
      Geben Sie einen Namen ein, unter dem Sie die aktuelle Listenkonfiguration speichern möchten. Dieser wird
      dann in der Liste Ihrer Konfigurationen angezeigt.
    </p>
    <p>Den Namen können Sie jederzeit wieder ändern.</p>
    <form-row>
      <mat-form-field fxFlex appearance="outline">
        <mat-label>Name der Konfiguration</mat-label>
        <input matInput [formControl]="formGroup.controls.name" />
        <mat-error *ngIf="formGroup.controls.name.touched && formGroup.controls.name.invalid">
          Bitte geben Sie einen Namen für die Konfiguration ein
        </mat-error>
      </mat-form-field>
    </form-row>
  </form>

  <div class="button-container" fxLayout="row" fxLayoutAlign="end stretch" fxLayoutGap="20px">
    <button mat-stroked-button color="primary" id="modal-close-button" (click)="cancel()">Abbrechen</button>
    <button mat-raised-button color="primary" id="modal-close-button" (click)="confirm(formGroup)">
      Speichern
    </button>
  </div>
</mat-dialog-content>
